import "core-js/features/array/from";
import "core-js/features/array/find-index";
import "core-js/features/symbol";
import "core-js/features/symbol/iterator";
import "core-js/features/number/is-integer";
import "core-js/features/string/includes";

import React from "react";
import { render } from "react-dom";

import mainState from "./state/state";
import { isBrowserSupported, captureQueryString, setLs, isValidUrlWithParams } from "./utils/utils";

import qs from "qs";
import ReactModal from "react-modal";

import App from "./App";
import { restoreSession } from "./actions/portalActions";
import globals from "./constants/env";
import { showAlert, showConfirm } from "./actions/alertActions";
import { captureInviteCode, configureAmplify } from "./utils/securityUtil";
import {
	attemptLaunchTabHandoff,
	getDefaultLaunchTabName,
	getRequestedHandoffTarget,
	initializeLaunchTabContext,
	initializeLaunchTabReceiver,
	renderLaunchTabHandoffScreen
} from "./utils/launchTabRouting";
import { initializeConnectivityScreening } from "./utils/connectivityUtil";
import { initializePostMessageListeners } from "./actions/mobileAppCommunicationActions";
import * as Types from "./constants/types";
import { registerDriveEditors } from "./actions/drive";
import { registerOrgPreferences } from "./actions/orgsActions";
import StylesheetEditor from "./components/styling/editor";
import ThemeEditor from "./components/theme/editor";
import JsonEditor from "./components/drive/editors/jsonEditor";
import PickerDatasourceEditor from "./components/drive/editors/pickerDatasourceEditor";
import JsEditor from "./components/drive/editors/jsEditor";
import TextEditor from "./components/drive/editors/textEditor";
import ProjectOpsTemplateEditor from "./components/drive/editors/projectOpsTemplateEditor";
import RetailTiersEditor from "./components/drive/editors/retailTiersEditor";
import TaxonomyEditor from "./components/drive/editors/taxonomyEditor";
import PhoneticsManager from "./components/ttsPhonetics/phoneticsManager";
import { getCustomHomeProjectTemplate, isProjectOpsEnabledForOrg, PROJECT_OPS_TEMPLATE_DRIVE_PATH, PROJECT_OPS_TEMPLATE_PREFERENCE_NAME } from "./utils/projectOpsUtils";
import { isRetailPricingEnabledForOrg, RETAIL_TIERS_DRIVE_PATH, RETAIL_TIERS_PREFERENCE_NAME } from "./utils/retailPricingUtils";
import { createTaxonomyTemplate, TAXONOMY_PREF_ACTIVITY, TAXONOMY_PREF_ALLOW_MANUAL_TAGS, TAXONOMY_PREF_DRIVE_METADATA } from "./utils/taxonomyUtils";
import { isTaxonomyEnabled } from "./utils/featureFlags";
import "./utils/fontawesome";
import ls from "local-storage";

if (mainState.get(["removeAllLogs"])) {
	// console.info = function () { }
	console.log = function () { };
	console.warn = function () { };
	console.error = function () { };
}

const isSearchV2Route = () =>
	window.location.pathname === "/playlistsSearchV2" ||
	window.location.pathname.startsWith("/playlistsSearchV2/") ||
	window.location.pathname === "/searchV2" ||
	window.location.pathname.startsWith("/searchV2/");

const isLegacyPlaylistsSearchV2Route = () =>
	window.location.pathname === "/playlistsSearchV2" ||
	window.location.pathname.startsWith("/playlistsSearchV2/");

const hasSearchOrgIdParam = () => {
	try {
		const params = new URLSearchParams(window.location.search || "");
		return !!(params.get("orgId") || params.get("organizationId"));
	} catch (_err) {
		return false;
	}
};

const isLightweightSearchV2Route = () => isLegacyPlaylistsSearchV2Route() || (isSearchV2Route() && hasSearchOrgIdParam());

if (!isBrowserSupported()) {
	// alert("Sorry, IE 11 is not supported :(\n\nIE 11 was released in 2013 and Microsoft has announced its end of life. AmbiFi runs on all modern browsers from Chrome to Firefox, to Microsoft Edge, to Apple Safari.");
	const renderError =
		<div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", padding: "25px" }}>
			<div style={{ color: "white", maxWidth: "800px" }}>
				<div>
					<h1>Sorry, IE 11 is not supported :(</h1>
					<p>IE 11 was released in 2013 and Microsoft has announced its end of life. AmbiFi runs on all modern browsers from Chrome to Firefox, to Microsoft Edge, to Apple Safari.</p>
				</div>
			</div>
		</div>;
	render(renderError, document.getElementById("root"));
} else {
	const normalizeDemoRole = (value) => {
		const normalizedValue = (value || "").toString().trim().toLowerCase();

		if (normalizedValue === "leader" || normalizedValue === "staff" || normalizedValue === "educator") {
			return normalizedValue;
		}

		return "";
	};

	const startAppBootstrap = () => {
		// render(<PlaylistsSearchMobile />, document.getElementById("root"));
		// Actually check for what we consider valid urls!
		// if (window.location.pathname !== "" && window.location.pathname !== "/" && window.location.pathname !== "/login") {

		// Only accept certain URLs for redirect
		if (isValidUrlWithParams(window.location.pathname)) {
			const origin = `${window.location.pathname}${window.location.search || ""}${window.location.hash || ""}`;
			console.info("SET ORIGIN", origin);
			setLs("origin", origin);
		} else {
			console.info("DONT SET ORIGIN BECAUSE / or /login");
		}


		// Delete if exist
		if (ls.get("ambifi-user-orgs")) {
			ls.remove("ambifi-user-orgs");
		}
		if (ls.get("ambifi-last-login-org")) {
			ls.remove("ambifi-last-login-org");
		}

		configureAmplify();
		initializeConnectivityScreening();
		initializePostMessageListeners();
		require("string.prototype.startswith"); // eslint-disable-line no-undef


		// kick off the polyfill!
		// smoothscroll.polyfill();

		// global function for inline linking
		//window.playerActionsInlineLinkUrl = ambifiWebPlayerActions.inlineLinkUrl;

		ReactModal.setAppElement("#root");

		// Creating our top-level component

		/**
		 * HS: This will override the default alerts, we can always remove this and use the
		 * fancy growls more selectively.
		 */
		if (globals.config.useFancyAlerts) {
			(() => {
				window.nativeAlert = window.alert;
				window.alert = function (message, cb) {
					showAlert(message, cb);
					// return proxied.apply(this, arguments);
					return false;
				};
				window.nativeConfirm = window.confirm;
				window.confirm = function (message, cb) {
					showConfirm(message, "Confirm", cb);
				};

			})(window.alert);
		} else {
			const alert2 = window.alert;
			window.nativeAlert = window.alert;
			window.alert = (message, cb) => {
				alert2(message);
				if (cb) {
					cb();
				}
			};
			const confirm2 = window.confirm;
			window.nativeConfirm = window.confirm;
			window.confirm = (message, cb) => {
				if (confirm2(message) && cb) {
					cb();
				}
			};
		}
		captureQueryString();
		captureInviteCode();

		const urlParsed = qs.parse(window.location.search, { ignoreQueryPrefix: true });
		if (urlParsed) {
			mainState.set(["appState", "urlParams"], urlParsed);
			const demoRole = normalizeDemoRole(urlParsed.demoRole);
			mainState.set(["appState", "demoRole"], demoRole);

			if (window.location.pathname === "/home") {
				mainState.set(["player", "selectedHomeTab"], demoRole === "leader" ? "team" : "myActivities");
			}

			// Set any params here need throughout
			if (urlParsed.hasOwnProperty("separateOutlineAndProps")) {
				mainState.set(["editor", "separateOutlineAndProps"], urlParsed.separateOutlineAndProps === "true" ? true : false);
				mainState.set(["appState", "editor", "separateOutlineAndProps"], urlParsed.separateOutlineAndProps === "true" ? true : false);
			}

			if (urlParsed.hasOwnProperty("previewVisible")) {
				mainState.set(["editor", "previewVisible"], urlParsed.previewVisible === "true" ? true : false);
				mainState.set(["appState", "editor", "previewVisible"], urlParsed.previewVisible === "true" ? true : false);
			}

		} else {
			console.warn("Parsed URL is not a valid Object", urlParsed);
		}

		window.addEventListener("beforeunload", (e) => {
			if (window.location.href.indexOf("/editor/") !== -1 || window.location.href.indexOf("/player/") !== -1) {
				const message = "Are you sure you want to leave this page? All unsaved changes will be lost.";
				(e || window.event).returnValue = message;
				return message;
			} else {
				return null;
			}
		}, true);

	const {
		TYPE_AMBIFI_PHONETICS,
		TYPE_AMBIFI_AUTHORING_DATASOURCE,
		TYPE_AMBIFI_PICKER_DATASOURCE,
		TYPE_AMBIFI_PICKER_DATASOURCE_ARRAY,
		TYPE_AMBIFI_PICKER_DATASOURCE_MAP,
		TYPE_AMBIFI_PICKER_DATASOURCE_BOTH,
		TYPE_AMBIFI_THEME,
		TYPE_AMBIFI_STYLESHEET,
		TYPE_AMBIFI_PLAYLISTS,
		TYPE_AMBIFI_WORKFLOW_STATES,
		TYPE_AMBIFI_PROJECT_OPS_TEMPLATE,
		TYPE_AMBIFI_PRICING_RETAIL_TIERS,
		TYPE_AMBIFI_TAXONOMY
	} = Types;

	const buildPickerDatasourceTemplate = (storageMode = "both") => {
		const familyId = "new-picker-family";
		const familyLabel = "New Picker Family";
		const arrayFamily = {
			id: familyId,
			label: familyLabel,
			items: [],
			allKeys: [],
			commonKeys: [],
			itemCount: 0
		};
		const mapFamily = {
			label: familyLabel,
			items: [],
			allKeys: [],
			commonKeys: [],
			itemCount: 0
		};

		if (storageMode === "array") {
			return JSON.stringify({ pickers: [arrayFamily] }, null, 4);
		}

		if (storageMode === "map") {
			return JSON.stringify({ pickersById: { [familyId]: mapFamily } }, null, 4);
		}

		return JSON.stringify({
			pickers: [arrayFamily],
			pickersById: {
				[familyId]: mapFamily
			}
		}, null, 4);
	};

	const buildAuthoringDatasourceTemplate = () => JSON.stringify({
		schemaVersion: 1,
		compileTargets: {},
		sources: {},
		collections: {},
		relationships: {},
		orders: {}
	}, null, 4);

	const taxonomyEnabled = isTaxonomyEnabled();
	const driveEditors = {
		"extension/json": {
			title: "JSON Document",
			icon: ["far", "file-code"],
			type: "application/json",
			contentType: "application/json",
			extension: "json",
			component: PickerDatasourceEditor,
			modalClassName: "picker-datasource-editor-modal"
		},
		"extension/js": {
			title: "Javascript Document",
			icon: ["far", "file-code"],
			type: "text/javascript",
			contentType: "text/javascript",
			extension: "js",
			component: JsEditor
		},
		[TYPE_AMBIFI_PHONETICS]: {
			title: "AmbiFi TTS Phonetics",
			icon: "language",
			type: TYPE_AMBIFI_PHONETICS,
			contentType: "application/json",
			extension: "json",
			component: PhoneticsManager
		},
		[TYPE_AMBIFI_AUTHORING_DATASOURCE]: {
			title: "Authoring Datasource",
			icon: "project-diagram",
			type: TYPE_AMBIFI_AUTHORING_DATASOURCE,
			contentType: "application/json",
			extension: "json",
			component: PickerDatasourceEditor,
			modalClassName: "picker-datasource-editor-modal",
			initialContent: buildAuthoringDatasourceTemplate()
		},
		[TYPE_AMBIFI_PICKER_DATASOURCE]: {
			title: "Picker Datasource",
			icon: "images",
			type: TYPE_AMBIFI_PICKER_DATASOURCE,
			contentType: "application/json",
			extension: "json",
			component: PickerDatasourceEditor,
			modalClassName: "picker-datasource-editor-modal",
			showInNewDocumentMenu: false
		},
		[TYPE_AMBIFI_PICKER_DATASOURCE_ARRAY]: {
			title: "Picker Datasource (Array)",
			icon: "images",
			type: TYPE_AMBIFI_PICKER_DATASOURCE_ARRAY,
			contentType: "application/json",
			extension: "json",
			component: PickerDatasourceEditor,
			modalClassName: "picker-datasource-editor-modal",
			initialContent: buildPickerDatasourceTemplate("array")
		},
		[TYPE_AMBIFI_PICKER_DATASOURCE_MAP]: {
			title: "Picker Datasource (Map)",
			icon: "images",
			type: TYPE_AMBIFI_PICKER_DATASOURCE_MAP,
			contentType: "application/json",
			extension: "json",
			component: PickerDatasourceEditor,
			modalClassName: "picker-datasource-editor-modal",
			initialContent: buildPickerDatasourceTemplate("map")
		},
		[TYPE_AMBIFI_PICKER_DATASOURCE_BOTH]: {
			title: "Picker Datasource (Array + Map)",
			icon: "images",
			type: TYPE_AMBIFI_PICKER_DATASOURCE_BOTH,
			contentType: "application/json",
			extension: "json",
			component: PickerDatasourceEditor,
			modalClassName: "picker-datasource-editor-modal",
			initialContent: buildPickerDatasourceTemplate("both")
		},
		[TYPE_AMBIFI_THEME]: {
			title: "Activity Theme",
			icon: "paint-brush",
			type: TYPE_AMBIFI_THEME,
			contentType: "application/json",
			extension: "json",
			component: ThemeEditor
		},
		[TYPE_AMBIFI_STYLESHEET]: {
			title: "Activity Stylesheet",
			icon: "paint-brush",
			type: TYPE_AMBIFI_STYLESHEET,
			contentType: "application/json",
			extension: "json",
			component: StylesheetEditor
		},
		[TYPE_AMBIFI_PLAYLISTS]: {
			title: "Playlists",
			icon: ["far", "file-code"],
			type: TYPE_AMBIFI_PLAYLISTS,
			contentType: "application/json",
			extension: "json",
			component: JsonEditor
		},
		[TYPE_AMBIFI_WORKFLOW_STATES]: {
			title: "Activity Wokflow States",
			icon: "cogs",
			type: TYPE_AMBIFI_WORKFLOW_STATES,
			contentType: "application/json",
			extension: "json",
			component: JsonEditor
		},
		[TYPE_AMBIFI_PROJECT_OPS_TEMPLATE]: {
			title: "Project Ops Template",
			icon: "project-diagram",
			type: TYPE_AMBIFI_PROJECT_OPS_TEMPLATE,
			contentType: "application/json",
			extension: "json",
			component: ProjectOpsTemplateEditor,
			modalClassName: "project-ops-template-editor-modal",
			initialContent: JSON.stringify(getCustomHomeProjectTemplate(), null, 4)
		},
		[TYPE_AMBIFI_PRICING_RETAIL_TIERS]: {
			title: "Pricing Retail Tiers",
			icon: "sliders-h",
			type: TYPE_AMBIFI_PRICING_RETAIL_TIERS,
			contentType: "application/json",
			extension: "json",
			component: RetailTiersEditor,
			modalClassName: "project-ops-template-editor-modal",
			initialContent: JSON.stringify({
				default: 2.6,
				baseField: "value",
				ranges: [
					{ min: 0, max: 1, value: 3 },
					{ min: 1000, max: 50000, value: 2 }
				]
			}, null, 4)
		},
		[TYPE_AMBIFI_TAXONOMY]: {
			title: "Controlled Vocabulary",
			icon: "tags",
			type: TYPE_AMBIFI_TAXONOMY,
			contentType: "application/json",
			extension: "json",
			component: TaxonomyEditor,
			modalClassName: "taxonomy-editor-modal",
			initialContent: JSON.stringify(createTaxonomyTemplate(), null, 4)
		},
		"ambifi/transcription": {
			title: "Transcription",
			icon: ["far", "file-code"],
			type: "ambifi/transcription",
			contentType: "application/json",
			extension: "json",
			component: JsonEditor
		},
		"extension/vtt": {
			title: "Video Text Tracks",
			icon: ["far", "file-code"],
			type: "text/vtt",
			contentType: "text/vtt",
			extension: "vtt",
			component: TextEditor
		},
		"extension/srt": {
			title: "SubRip File (Subtitles)",
			icon: ["far", "file-code"],
			type: "application/x-subrip",
			contentType: "application/x-subrip",
			extension: "srt",
			component: TextEditor
		},
		// "ambifi/subtitles": {
		// 	title: "SubRip File (Subtitles)",
		// 	icon: ["far", "file-code"],
		// 	type: "ambifi/subtitles",
		// 	contentType: "text/vtt",
		// 	extension: "srt",
		// 	component: TextEditor
		// },
		// "ambifi/subtitles-vtt": {
		// 	title: "SubRip File (Subtitles)",
		// 	icon: ["far", "file-code"],
		// 	type: "ambifi/subtitles-vtt",
		// 	contentType: "application/x-subrip",
		// 	extension: "vtt",
		// 	component: TextEditor
		// }
	};
	if (!taxonomyEnabled) {
		delete driveEditors[TYPE_AMBIFI_TAXONOMY];
	}
	registerDriveEditors(driveEditors);

	const orgPreferences = [
		{
			title: "Text-to-Speech Phonetics",
			description: "Select or create a dictionary of phonetics to help your assistant to pronounce your organizations vocabulary properly.",
			driveResource: true,
			driveResourceType: TYPE_AMBIFI_PHONETICS,
			singleSelect: true,
			orgPreferenceName: "tts-phonetics",
			enableEditing: true,
			showEditorWhenEmpty: true,
			savePathWhenEmpty: "private/_system/tts-phonetics/tts-phonetics.json"
		},
		{
			title: "Activity Theme",
			description: "Select or create a global activity theme that will be applied to all activities of your organization.",
			driveResource: true,
			driveResourceType: TYPE_AMBIFI_THEME,
			singleSelect: true,
			orgPreferenceName: "theme",
			enableEditing: true,
			showEditorWhenEmpty: true,
			savePathWhenEmpty: "private/_system/themes/organization-theme.json"
		},
		{
			title: "Activity Stylesheet",
			description: "Select or create a global activity stylesheet that will be applied to all activities of your organization. It allows finer level control over the look and feel of the activity and also allows to define classes that can then be applied to items.",
			driveResource: true,
			driveResourceType: TYPE_AMBIFI_STYLESHEET,
			singleSelect: true,
			orgPreferenceName: "stylesheet",
			enableEditing: true,
			showEditorWhenEmpty: true,
			savePathWhenEmpty: "private/_system/stylesheets/organization-stylesheet.json"
		},
		{
			title: "Fonts",
			description: "Paste the URL to one or more fonts, these fonts will then be included in your activities for use.",
			driveResource: false,
			componentType: "codemirror",
			componentOptions: {
				mode: "htmlmixed",
				lineNumbers: true
			},
			multiline: true,
			orgPreferenceName: "fonts",
			enableEditing: true
		},
		{
			title: "Playlists",
			description: "Select or create global playlists.",
			driveResource: true,
			driveResourceType: TYPE_AMBIFI_PLAYLISTS,
			singleSelect: true,
			orgPreferenceName: "playlists",
			enableEditing: true,
			showEditorWhenEmpty: true,
			savePathWhenEmpty: "private/_system/playlists/organization-playlists.json"
		},
		{
			title: "Drive Metadata Vocabulary",
			description: "Select or create the controlled vocabulary used by the Drive metadata editor.",
			driveResource: true,
			driveResourceType: TYPE_AMBIFI_TAXONOMY,
			driveResourceAcceptTypes: [TYPE_AMBIFI_TAXONOMY, "application/json", "extension/json"],
			singleSelect: true,
			orgPreferenceName: TAXONOMY_PREF_DRIVE_METADATA,
			enableEditing: true,
			showEditorWhenEmpty: true,
			savePathWhenEmpty: "private/_system/taxonomies/drive-metadata-vocabulary.json",
			isVisible: (selectedOrg = {}, props = {}) => isTaxonomyEnabled(props.urlParams, selectedOrg)
		},
		{
			title: "Activity Vocabulary",
			description: "Select or create the controlled vocabulary used by activity authoring tags.",
			driveResource: true,
			driveResourceType: TYPE_AMBIFI_TAXONOMY,
			driveResourceAcceptTypes: [TYPE_AMBIFI_TAXONOMY, "application/json", "extension/json"],
			singleSelect: true,
			orgPreferenceName: TAXONOMY_PREF_ACTIVITY,
			enableEditing: true,
			showEditorWhenEmpty: true,
			savePathWhenEmpty: "private/_system/taxonomies/activity-vocabulary.json",
			isVisible: (selectedOrg = {}, props = {}) => isTaxonomyEnabled(props.urlParams, selectedOrg)
		},
		{
			title: "Allow Manual Tags",
			description: "Allow users to reveal a warning-gated manual tag entry field when a controlled vocabulary does not contain the needed tag.",
			driveResource: false,
			componentType: "checkbox",
			orgPreferenceName: TAXONOMY_PREF_ALLOW_MANUAL_TAGS,
			defaultValue: true,
			isVisible: (selectedOrg = {}, props = {}) => isTaxonomyEnabled(props.urlParams, selectedOrg)
		},
		{
			title: "Organization Search Index",
			description: "Configuration properties for the organization search index.",
			driveResource: false,
			componentType: "codemirror",
			componentOptions: {
				mode: "javascript",
				lineNumbers: true
			},
			multiline: true,
			orgPreferenceName: "org-search-index",
			enableEditing: true
		},
		{
			title: "Status Search Index",
			description: "Configuration properties for the status search index.",
			driveResource: false,
			componentType: "codemirror",
			componentOptions: {
				mode: "javascript",
				lineNumbers: true
			},
			multiline: true,
			orgPreferenceName: "status-search-index",
			enableEditing: true
		},
		{
			title: "Project Ops Template",
			description: "Select or create the default Project Ops workflow template for this organization.",
			driveResource: true,
			driveResourceType: TYPE_AMBIFI_PROJECT_OPS_TEMPLATE,
			singleSelect: true,
			orgPreferenceName: PROJECT_OPS_TEMPLATE_PREFERENCE_NAME,
			enableEditing: true,
			showEditorWhenEmpty: true,
			savePathWhenEmpty: PROJECT_OPS_TEMPLATE_DRIVE_PATH,
			isVisible: (selectedOrg = {}) => isProjectOpsEnabledForOrg(selectedOrg.id)
		},
		{
			title: "Pricing Retail Tiers",
			description: "Select or create the retail-tier configuration used when pricing is switched to Retail mode.",
			driveResource: true,
			driveResourceType: TYPE_AMBIFI_PRICING_RETAIL_TIERS,
			driveResourceAcceptTypes: [TYPE_AMBIFI_PRICING_RETAIL_TIERS, "application/json", "extension/json"],
			singleSelect: true,
			orgPreferenceName: RETAIL_TIERS_PREFERENCE_NAME,
			enableEditing: true,
			showEditorWhenEmpty: true,
			savePathWhenEmpty: RETAIL_TIERS_DRIVE_PATH,
			isVisible: (selectedOrg = {}) => isRetailPricingEnabledForOrg(selectedOrg.id)
		}
	];
	if (!taxonomyEnabled) {
		[
			TAXONOMY_PREF_DRIVE_METADATA,
			TAXONOMY_PREF_ACTIVITY,
			TAXONOMY_PREF_ALLOW_MANUAL_TAGS
		].forEach((preferenceName) => {
			const index = orgPreferences.findIndex((preference) => preference.orgPreferenceName === preferenceName);
			if (index !== -1) {
				orgPreferences.splice(index, 1);
			}
		});
	}
	registerOrgPreferences(orgPreferences);

		// Rendering the app
		if (isLightweightSearchV2Route()) {
			render(<App />, document.getElementById("root"));
		} else {
			render(<App />, document.getElementById("root"), restoreSession);
		}
	};

	const launchTabContext = initializeLaunchTabContext();

	initializeLaunchTabReceiver({
		tabName: launchTabContext.tabName
	});

	const pendingHandoffTarget = getRequestedHandoffTarget() !== "";

	if (pendingHandoffTarget) {
		attemptLaunchTabHandoff().then((handoffResult) => {
			if (handoffResult && handoffResult.handedOff) {
				renderLaunchTabHandoffScreen(handoffResult.targetTabName || getDefaultLaunchTabName());
				return;
			}

			try {
				window.history.replaceState(window.history.state, document.title, handoffResult.launchPath || window.location.href);
			} catch (_err) {
				// Ignore history cleanup failures.
			}
			startAppBootstrap();
		});
	} else {
		startAppBootstrap();
	}

	// (async () => {
	// 	try {
	// 		await restoreSession();

	// 		// Rendering the app
	// 		render(<App />, document.getElementById("root"));
	// 	} catch (e) {
	// 	}
	// })();
}
